// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadasLote_ScheduleBulkMessagesInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /mensagens_programadas_lote/schedule_bulk_messages
 *
 * Schedules a batch of WhatsApp messages via scheduler-service. Each item in
 * $messages must include cliente_id, template_id and whatsappfranquia_id.
 * $bulk_data and $customers_data are persisted alongside the bulk-operation
 * record for audit and reporting purposes.
 *
 * Note: typed-array fields below are hydrated as Row objects by InputContract
 * (see fillArrayValue + fillNestedObject). customValidate() and downstream
 * controller code must access them via object properties, not array keys.
 */
import type { MensagensProgramadasLote_BulkDataInputRow } from './MensagensProgramadasLote_BulkDataInputRow'
import type { MensagensProgramadasLote_GetFilteredCustomersRow } from './MensagensProgramadasLote_GetFilteredCustomersRow'
import type { MensagensProgramadasLote_ScheduleBulkMessageInputRow } from './MensagensProgramadasLote_ScheduleBulkMessageInputRow'
import { registerContract } from './validate'

export interface MensagensProgramadasLote_ScheduleBulkMessagesInput {
messages: MensagensProgramadasLote_ScheduleBulkMessageInputRow[]
current_datetime: string
bulk_data: MensagensProgramadasLote_BulkDataInputRow
customers_data: MensagensProgramadasLote_GetFilteredCustomersRow[]
}

registerContract('MensagensProgramadasLote_ScheduleBulkMessagesInput', {
  messages: {
    type: 'array',
    required: true,
    items: {
      cliente_id:          { type: 'number',  required: true },
      template_id:         { type: 'number',  required: true },
      whatsappfranquia_id: { type: 'number',  required: true },
      user_id:             { type: 'number',  required: false },
    },
  },
  current_datetime: { type: 'string',  required: true },
  bulk_data: {
    type: 'object',
    required: true,
    fields: {
      periodo_inicio: { type: 'string',  required: true },
      periodo_fim:    { type: 'string',  required: true },
      franquias:      { type: 'array',   required: false },
      template_id:    { type: 'number',  required: true },
    },
  },
  customers_data: {
    type: 'array',
    required: true,
    items: {
      cliente_id:                              { type: 'number',  required: true },
      cliente_nome:                            { type: 'string',  required: true },
      cliente_franquia_id:                     { type: 'number',  required: true },
      cliente_telefone:                        { type: 'string',  required: false },
      cliente_ddd:                             { type: 'string',  required: false },
      cliente_ddi:                             { type: 'string',  required: false },
      cliente_data_ultimo_compromisso:         { type: 'string',  required: false },
      cliente_data_ultimo_contato_fidelizacao: { type: 'string',  required: false },
      cliente_bairro:                          { type: 'string',  required: false },
      cliente_location_id:                     { type: 'number',  required: false },
      cliente_location_type:                   { type: 'string',  required: false },
      franquia:                                { type: 'string',  required: false },
      localidade:                              { type: 'string',  required: false },
    },
  },
})
